module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingOptionForm"
    }
  }, [_c('div', {
    attrs: {
      "id": "option-box"
    }
  }, [_c('div', {
    staticClass: "option-content"
  }, [_c('label', [_vm._v("授業の種類：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationOption.reservationType),
      expression: "reservationOption.reservationType"
    }],
    attrs: {
      "id": "radio-reservation-normal",
      "type": "radio",
      "value": "通常"
    },
    domProps: {
      "checked": _vm._q(_vm.reservationOption.reservationType, "通常")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.reservationOption, "reservationType", "通常")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio-reservation-normal"
    }
  }, [_vm._v("通常授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationOption.reservationType),
      expression: "reservationOption.reservationType"
    }],
    attrs: {
      "id": "radio-reservation-normal-first",
      "type": "radio",
      "value": "通常初回"
    },
    domProps: {
      "checked": _vm._q(_vm.reservationOption.reservationType, "通常初回")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.reservationOption, "reservationType", "通常初回")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio-reservation-normal-first"
    }
  }, [_vm._v("通常初回授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationOption.reservationType),
      expression: "reservationOption.reservationType"
    }],
    attrs: {
      "id": "radio-reservation-short",
      "type": "radio",
      "value": "短期"
    },
    domProps: {
      "checked": _vm._q(_vm.reservationOption.reservationType, "短期")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.reservationOption, "reservationType", "短期")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio-reservation-short"
    }
  }, [_vm._v("短期講座")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationOption.reservationType),
      expression: "reservationOption.reservationType"
    }],
    attrs: {
      "id": "radio-reservation-short",
      "type": "radio",
      "value": "短期初回"
    },
    domProps: {
      "checked": _vm._q(_vm.reservationOption.reservationType, "短期初回")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.reservationOption, "reservationType", "短期初回")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio-reservation-short-first"
    }
  }, [_vm._v("短期初回講座")])]), _vm._v(" "), _c('div', {
    staticClass: "option-content"
  }, [_c('label', [_vm._v("配布物（確認テスト）等：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationOption.hasTest),
      expression: "reservationOption.hasTest"
    }],
    attrs: {
      "id": "radio-test-false",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.reservationOption.hasTest, false)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.reservationOption, "hasTest", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio-test-false"
    }
  }, [_vm._v("なし")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservationOption.hasTest),
      expression: "reservationOption.hasTest"
    }],
    attrs: {
      "id": "radio-test-true",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.reservationOption.hasTest, true)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.reservationOption, "hasTest", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio-test-true"
    }
  }, [_vm._v("あり")])]), _vm._v(" "), _c('div', {
    staticClass: "option-content"
  }, [_c('label', [_vm._v("授業での連絡事項があれば記入してください（任意）")]), _vm._v(" "), _c('div', {
    staticClass: "text-area"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "連絡事項があれば入力してください",
      "rows": "3"
    },
    model: {
      value: (_vm.reservationOption.reservationMessage),
      callback: function($$v) {
        _vm.$set(_vm.reservationOption, "reservationMessage", $$v)
      },
      expression: "reservationOption.reservationMessage"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c35dec2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReschedulingPage/ReschedulingOptionForm.vue
// module id = 734
// module chunks = 0